// src/index.js
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

// Import the CSS through Webpack. This will be handled by your loaders.
import '@fortawesome/fontawesome-svg-core/styles.css';

import { faAddressCard } from '@fortawesome/free-solid-svg-icons/faAddressCard';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons/faAnglesDown';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons/faAnglesLeft';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons/faAnglesRight';
import { faAnglesUp } from '@fortawesome/free-solid-svg-icons/faAnglesUp';
import { faArchive } from '@fortawesome/free-solid-svg-icons/faArchive';
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons/faArrowUpFromBracket';
import { faAtom } from '@fortawesome/free-solid-svg-icons/faAtom';
import { faAward } from '@fortawesome/free-solid-svg-icons/faAward';
import { faBackward } from '@fortawesome/free-solid-svg-icons/faBackward';
import { faBackwardFast } from '@fortawesome/free-solid-svg-icons/faBackwardFast';
import { faBackwardStep } from '@fortawesome/free-solid-svg-icons/faBackwardStep';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBlog } from '@fortawesome/free-solid-svg-icons/faBlog';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faBookReader } from '@fortawesome/free-solid-svg-icons/faBookReader';
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons/faCalendarDays';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faChess } from '@fortawesome/free-solid-svg-icons/faChess';
import { faChessBishop } from '@fortawesome/free-solid-svg-icons/faChessBishop';
import { faChessBoard } from '@fortawesome/free-solid-svg-icons/faChessBoard';
import { faChessKing } from '@fortawesome/free-solid-svg-icons/faChessKing';
import { faChessKnight } from '@fortawesome/free-solid-svg-icons/faChessKnight';
import { faChessPawn } from '@fortawesome/free-solid-svg-icons/faChessPawn';
import { faChessQueen } from '@fortawesome/free-solid-svg-icons/faChessQueen';
import { faChessRook } from '@fortawesome/free-solid-svg-icons/faChessRook';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faCircleDown } from '@fortawesome/free-solid-svg-icons/faCircleDown';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faCircleLeft } from '@fortawesome/free-solid-svg-icons/faCircleLeft';
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons/faCircleMinus';
import { faCirclePause } from '@fortawesome/free-solid-svg-icons/faCirclePause';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons/faCirclePlay';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons/faCirclePlus';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons/faCircleQuestion';
import { faCircleRight } from '@fortawesome/free-solid-svg-icons/faCircleRight';
import { faCircleStop } from '@fortawesome/free-solid-svg-icons/faCircleStop';
import { faCircleUp } from '@fortawesome/free-solid-svg-icons/faCircleUp';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faClipboard } from '@fortawesome/free-solid-svg-icons/faClipboard';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons/faClipboardCheck';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import { faClone } from '@fortawesome/free-solid-svg-icons/faClone';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons/faCloudArrowDown';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons/faCloudArrowUp';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons/faEllipsisVertical';
import { faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons/faEnvelopeOpen';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons/faFileArrowDown';
import { faFileArrowUp } from '@fortawesome/free-solid-svg-icons/faFileArrowUp';
import { faFileCircleCheck } from '@fortawesome/free-solid-svg-icons/faFileCircleCheck';
import { faFileCircleMinus } from '@fortawesome/free-solid-svg-icons/faFileCircleMinus';
import { faFileCirclePlus } from '@fortawesome/free-solid-svg-icons/faFileCirclePlus';
import { faFileCircleXmark } from '@fortawesome/free-solid-svg-icons/faFileCircleXmark';
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport';
import { faFileImport } from '@fortawesome/free-solid-svg-icons/faFileImport';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons/faFloppyDisk';
import { faFolderMinus } from '@fortawesome/free-solid-svg-icons/faFolderMinus';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faFolderPlus } from '@fortawesome/free-solid-svg-icons/faFolderPlus';
import { faForward } from '@fortawesome/free-solid-svg-icons/faForward';
import { faForwardFast } from '@fortawesome/free-solid-svg-icons/faForwardFast';
import { faForwardStep } from '@fortawesome/free-solid-svg-icons/faForwardStep';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faLinkSlash } from '@fortawesome/free-solid-svg-icons/faLinkSlash';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPause } from '@fortawesome/free-solid-svg-icons/faPause';
import { faPaste } from '@fortawesome/free-solid-svg-icons/faPaste';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPlusMinus } from '@fortawesome/free-solid-svg-icons/faPlusMinus';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';
import { faRotate } from '@fortawesome/free-solid-svg-icons/faRotate';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons/faRotateLeft';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons/faRotateRight';
import { faRss } from '@fortawesome/free-solid-svg-icons/faRss';
import { faSitemap } from '@fortawesome/free-solid-svg-icons/faSitemap';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons/faSquareCheck';
import { faSquareMinus } from '@fortawesome/free-solid-svg-icons/faSquareMinus';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons/faSquarePlus';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons/faSquareXmark';
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons/faTrashCan';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faWifi } from '@fortawesome/free-solid-svg-icons/faWifi';
import { faVolumeHigh } from '@fortawesome/free-solid-svg-icons/faVolumeHigh';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faDropbox } from '@fortawesome/free-brands-svg-icons/faDropbox';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';

library.add(
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAnglesDown,
  faAnglesLeft,
  faAnglesRight,
  faAnglesUp,
  faArchive,
  faArrowUpFromBracket,
  faAtom,
  faAward,
  faBackward,
  faBackwardFast,
  faBackwardStep,
  faBars,
  faBlog,
  faBook,
  faBookReader,
  faBuilding,
  faCalendarDays,
  faCheck,
  faChess,
  faChessBishop,
  faChessBoard,
  faChessKing,
  faChessKnight,
  faChessPawn,
  faChessQueen,
  faChessRook,
  faCircle,
  faCircleCheck,
  faCircleDown,
  faCircleExclamation,
  faCircleInfo,
  faCircleLeft,
  faCircleMinus,
  faCirclePause,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleRight,
  faCircleStop,
  faCircleUp,
  faCircleXmark,
  faClipboard,
  faClipboardCheck,
  faClipboardList,
  faClone,
  faCloudArrowDown,
  faCloudArrowUp,
  faCopy,
  faDownload,
  faEllipsis,
  faEllipsisVertical,
  faEnvelopeOpen,
  faExclamation,
  faEye,
  faFileArrowDown,
  faFileArrowUp,
  faFileCircleCheck,
  faFileCircleMinus,
  faFileCirclePlus,
  faFileCircleXmark,
  faFileExport,
  faFileImport,
  faFloppyDisk,
  faFolderMinus,
  faFolderOpen,
  faFolderPlus,
  faForward,
  faForwardFast,
  faForwardStep,
  faGlobe,
  faGraduationCap,
  faHome,
  faInfo,
  faLanguage,
  faLink,
  faLinkSlash,
  faMapMarkerAlt,
  faMinus,
  faPause,
  faPaste,
  faPenToSquare,
  faPlay,
  faPlus,
  faPlusMinus,
  faPowerOff,
  faQuestion,
  faReply,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faRss,
  faSitemap,
  faSquareCheck,
  faSquareMinus,
  faSquarePlus,
  faSquareXmark,
  faStop,
  faTags,
  faTrashCan,
  faTriangleExclamation,
  faUpload,
  faUserTie,
  faWifi,
  faVolumeHigh,
  faXmark,
  faApple,
  faDropbox,
  faFacebook,
  faGithub,
  faGoogle,
  faLinkedin,
  faYoutube,
  faXTwitter
);

dom.watch();
